<template> 
    <!-- 注册、开户、找回密码等应用，宽60rem 外层用 -->
    <section class="container-one">
        <div>
            <slot></slot>
        </div>
    </section>
</template>
<script>
    export default {
        props:['classCpt']
    }
</script>
<style lang="less" scoped>
    section.container-one{
        background: #F7F7F7;
        padding:1rem 0;
        >div{
            min-height: 5rem;
            background:#fff;
            width:60rem;
            margin:0 auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/containerOne.vue